export default __webpack_public_path__ + "static/media/recovery.2f19feac.svg";